module.exports = __webpack_public_path__ + "static/ss5.672773ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss5.png
// module id = 1201
// module chunks = 81679748166845